export default {
  // baseUrl: 'http://xiaobiaoge.tpddns.cn:8093',
  // baseUrl: 'http://www.huozhe666.com:8093',
  baseUrl: 'http://www.huozhe666.com:8097',
  myBaseUrl: '/mobile/',
  fileBaseUrl: 'http://www.huozhe666.com:9010'
  // fileBaseUrl: 'http://xiaobiaoge.tpddns.cn:9010'
}
